// JavaScript source code
/* 
 *  Copyright (c) Intel Corporation.  All Rights Reserved.
 *
 */
/*--!!!!!ATTENTION!!!!!-----DO NOT DELETE code inside Webpack Macros,it will be used in Analytics SDK for Web */

// #IFDEF WebPack

import { ModuleManager, JSONManager, globalEngine} from "./Init";
import { getMessageBus } from "./bootstrap_web_ext"
import { getSystemPlugin , GetKeyValueFromINIFile} from "./common";
import { logNormal , logInformation , logWarning , logError, logDebug, logConsole , logRawTrack , logTransports , logAutomationError} from "./bootstrap_web_ext";

// #ENDIF WebPack
var Create_data_collector = function ()
{
    var data_collector =
    {
        /**********************************************************************************************
        ***********************************************************************************************
                Public Functions
        ***********************************************************************************************
        ***********************************************************************************************/

        /* Starts the data_collector: 
        *   Loads JSON file data_items.json
        *   Marks all items as expired
        *   Creates farmers and refresher objects
        */
        "setup": function ()
        {
            try
            {
                this._logInformation('Setup Started.');

                this._loadDefinitions();
                this._farmers = this._createFarmers(this);
                this._refreshers = this._createRefreshers(this);

                if (!this._farmers || !this._refreshers || !this._definitions)
                {
                    this._logError('Setup failed: farmers(' + this._farmers + '). refreshers(' + this._refreshers + '). definitions(' + this._definitions + ')');
                    return;
                }

                // Mark all items as expired
                var keys  = [];
                for (var key in this._definitions)
                {
                    keys.push(key);
                }
                this.markDataExpired(keys);

                this._logInformation('Setup Done.');
            }
            catch (e)
            {
                this._logError('Setup failed: ' + e.message);
            }
        },

        /* Retrieves data points from diffrent sources
         * Returns a JSON object with key-value pairs {"key1":"value1", "key2":"value2" .... }
         * PARAMS
         *  itemsList - an array of item names or a single item name to be retrieved
         *
         */
        "get": function (itemsList)
        {
            try
            {
                //this._logInformation('expiredItems' + JSON.stringify(this._expiredItems));
                var buff = null;
                if (typeof itemsList === 'string')
                {
                    buff = itemsList;
                    itemsList = [itemsList];
                }

                if (!itemsList instanceof Array)
                {
                    this._logError('get: itemsList not an array (' + itemsList + ').');
                    return {};
                }

                // Load expired data items
                var expiredDataPoints = this._getCommonElements(this._expiredItems, itemsList);
                this._updateCache(expiredDataPoints, false);

                // Perfom operations on operation expired data item
                var operationExpiredDatapoints = this._getCommonElements(this._operationExpiredItems, itemsList);
                this._updateCache(operationExpiredDatapoints, true);
                var collection = this._createCollection(itemsList);

                return buff ? collection[buff] : collection;
            }
            catch (e)
            {
                this._logError('get: ' + e.message);
                return {};
            }
        },

        /* Marks data points as expired
         *
         * PARAMS
         *  itemsList - an array of item names or a single item name to be marked as expired
         *
         */
        "markDataExpired": function (itemsList) // an array of itmes
        {
            try
            {
                this._logInformation('Marking items as expired: ' + JSON.stringify(itemsList));
                if (typeof itemsList === 'string')
                {
                    itemsList = [itemsList];
                }

                if (!itemsList instanceof Array)
                {
                    this._logError('markDataExpired: itemsList not an array (' + itemsList + ').');
                    return;
                }

                // Check for circular dependency
                for (var idx in itemsList)
                {
                    if(this._arrayIncludes(this._expiryQueue, itemsList[idx]))
                    {
                        this._logError('Circular dependency detected for ' + itemsList[idx]);
                        return;
                    }
                }

                // Load expired data items
                for (var idx in itemsList)
                {
                    var key = itemsList[idx];
                    if (!this._arrayIncludes(this._expiredItems, key))
                    {
                        this._expiryQueue.push(key);
                        // Recurively expire source items if collected from data store
                        try
                        {
                            if (this._definitions[key]['source'] == 'dataCollector')
                            {
                                this._logInformation('Marking parent items expired for (' + key + ')')
                                this.markDataExpired(this._definitions[key]['params']);
                            }
                        }
                        catch (e)
                        {
                            this._logError('Exception when marking parent keys expired for (' + key + ')');
                        }

                        this._expiredItems.push(key);
                        this._removeItemFromArray(this._expiryQueue, key);
                    }
                }
            }
            catch (e)
            {
                this._logError('markDataExpired: ' + e.message);
            }
        },

        /* Marks data points operations as expired
         *
         * PARAMS
         *  itemsList - an array of item names or a single item name to be retrieved
         *
         */
        "markDataOperationExpired": function (itemsList) // an array of itmes
        {
            try
            {
                this._logInformation('Marking items as operation expired: ' + JSON.stringify(itemsList));
                if (typeof itemsList === 'string')
                {
                    itemsList = [itemsList];
                }

                if (!itemsList instanceof Array)
                {
                    this._logError('markDataOperationExpired: itemsList not an array (' + itemsList + ').');
                    return;
                }

                // Load expired data items
                for (var idx in itemsList)
                {
                    var key = itemsList[idx];
                    if (!this._arrayIncludes(this._operationExpiredItems, key))
                    {
                        this._operationExpiredItems.push(key);
                    }
                }
            }
            catch (e)
            {
                this._logError('markDataOperationExpired: ' + e.message);
            }
        },


        /* Used to notify the data_collector that a message was received on the msg bus
        * PARAMS:
        *   msg: Message name
        * RETURN:
        *   true if the message was subscribed to, false otherwise
        */
        "notifyMsg": function (msg)
        {
            try
            {
                this._logInformation('notifyMsg: New msg(' + msg + ')');

                var expiredDataItems = this._subscribedMsgs[msg];
                if (!expiredDataItems)
                {
                    return false;
                }

                this.markDataExpired(expiredDataItems);
                return true;
            }
            catch (e)
            {
                this._logError('notifyMsg: ' + e.message);
            }
        },

        /* Checks if items are expired
         * PARAMS
         *  itemsList - an array of item names or a single item name to be checked
         * RETURN:
         *  true if one or more elements expired, false otherwise
         *
         */
        "isExpired": function (itemsList)
        {
            try
            {
                if (typeof itemsList === 'string')
                {
                    itemsList = [itemsList];
                }

                if (!itemsList instanceof Array)
                {
                    this._logError('isExpired: itemsList not an array (' + itemsList + ').');
                    return false;
                }

                // Load expired data items
                var expiredDataPoints = this._getCommonElements(this._expiredItems, itemsList);
                return (expiredDataPoints.length === 0) ? false : true;
                
            }
            catch (e)
            {
                this._logError('isExpired: ' + e.message);
                return false;
            }
        },

        /**********************************************************************************************
        ***********************************************************************************************
                Private Functions
        ***********************************************************************************************
        ***********************************************************************************************/
        /* Creates a collection of key-value parameters by retrieving data points from the data_collector
         *
         * PARAMS
         *  itemsList - an array of item names
         *
         */
        "_createCollection": function (itemsList)
        {
            try
            {
                var collection = {};
                for (var idx in itemsList)
                {
                    var itemName = itemsList[idx];
                    collection[itemName] = (this._cache[itemName] !== undefined) ? this._cache[itemName] : '[unknown]';
                }

                // this._logInformation('_createCollection: New collection created: ' + JSON.stringify(collection));
                return collection;
            }
            catch (e)
            {
                this._logError('_createCollection: ' + e.message);
                return {};
            }
        },

        /* Allows a datapoint to subscribe to a msg
        * PARAMS:
        *   name: datapoint name
        *   msgs: array of msgs' names to subscribe to
        */
        "_subscribeToMsgBusRefreshMsgs": function (name, msgs)
        {
            try
            {
                if (!name)
                {
                    this._logError('_subscribeToMsgBusRefreshMsgs: Called with no name provided');
                    return;
                }

                if (!msgs || msgs.length === 0)
                {
                    return;
                }


                this._logInformation('_subscribeToMsgBusRefreshMsgs: Subscribing for (' + name + '). msgs:' + JSON.stringify(msgs));
                for (var idx in msgs)
                {
                    try
                    {
                        var msgName = msgs[idx];
                        if (!this._subscribedMsgs[msgName])
                        {
                            this._subscribedMsgs[msgName] = [];
                            var msgbus = getMessageBus();
                            msgbus.Subscribe(msgName);
                        }
                        if (!this._arrayIncludes(this._subscribedMsgs[msgName],name))
                        {
                            this._subscribedMsgs[msgName].push(name);
                        }
                    }
                    catch (e)
                    {
                        this._logError('_subscribeToMsgBusRefreshMsgs:loop: ' + e.message);
                    }
                }

            }
            catch (e)
            {
                this._logError('_subscribeToMsgBusRefreshMsgs: ' + e.message);
            }
        },

        /* Loads JSON file data_items.json
        */
        "_loadDefinitions": function ()
        {
            try
            {
                this._definitions = JSONManager.create("data_items");
            }
            catch (e)
            {
                this._logError('_loadDefinitions: Exception loading data_items: ' + e.message);
            }
        },

        /* Collects the data points and process them
        *
        * PARAMS:
        *   itemsList: an array of item names
        *   operationOnly: If true, the last harvest value is used instead of reharvesting
        */
        "_updateCache": function (itemsList, operationOnly)
        {
            if (!(itemsList instanceof Array))
            {
                this._logError('loadToStore: itemsList not an array (' + itemsList + ').');
                return;
            }

            // this._logInformation('_updateCache: Requested Items ' + JSON.stringify(itemsList) + '. operationOnly(' + operationOnly + ')');

            if (itemsList.length === 0)
            {
                // Nothing to do here
                return;
            }

            for (var idx in itemsList)
            {
                try
                {
                    this._loadSingleItem(itemsList[idx], operationOnly);
                }
                catch (e)
                {
                    this._logError('_updateCache: Issue with loading singleItem for (' + itemsList[idx] + ')');
                }
            }
        },

        /* Collects a single data point and processes it
        *       Items are stored in the data_collector
        *
        * PARAMS:
        *   itemName: target data_item name
        *   operationOnly: If true, the last harvest value is used instead of reharvesting
        */
        "_loadSingleItem": function (itemName, operationOnly)
        {
            var itemDefinition = this._definitions[itemName];

            if (!itemDefinition)
            {
                this._logError('loadItem: No item definition found for (' + itemName + ')');
                this._cache[itemName] = '[unknown]';
                return;
            }

            if (!operationOnly)
            {
                this._harvest(itemName, itemDefinition);
            }

            // Apply operation
            var postOperationValue = this._processOperation(itemName,  itemDefinition['operationConfig']);
            
            // Apply rule
            var rules = ModuleManager.getSingleton("rules");
            var postRuleValue = rules.apply(postOperationValue, itemDefinition['rule']);
            //this._logInformation('_loadSingleItem: Storing:: ItemName(' + itemName + '). PostRule(' + postRuleValue+ ')' );

            // Store
            this._cache[itemName] = postRuleValue;

            // Process Refresh
            this._setRefreshers(itemName, itemDefinition['refresh']);
        },

        /* Reads a value based on it's definition
        *   Will call the farmers to do the harvesting
        *   No operations are done in this stage
        *   Detects circular dependency for items already being collected
        *
        * PARAMS:
        *   itemName: target data_item name
        *   itemDefinition: item definition retrieved from data_items.json
        */
        "_harvest": function (itemName, itemDefinition)
        {
            try
            {
                this._logInformation('_harvest: Harvesting(' + itemName + ')');

                //Since we can collect data from the current datastore, we need to ensure no circular dependency
                // If the itemName is already being collected, we have a circular dependency
                if (this._arrayIncludes(this._harvestQueue, itemName))
                {
                    this._rawDataStore[itemName] = null;
                    this._removeItemFromArray(this._expiredItems, itemName); // Don't mark it expired
                    this._logError('_harvest: Circular dependency detected for (' + itemName + ')');
                    return;
                }

                if (this._farmers[itemDefinition['source']] === null)
                {
                    this._logError('_harvest: Unknown harvesting function (' + itemDefinition['source'] + ')');
                    this._rawDataStore[itemName] = null;
                    return;
                }

                // Add item to harvestQueue (Which contains list of items being collected)
                this._harvestQueue.push(itemName);

                // this._logInformation('_harvest: Calling farmer: ' + itemDefinition['source'] + '. for item(' + itemName + ')');

                var harvestValue = this._farmers[itemDefinition['source']](itemDefinition['params']);
                this._rawDataStore[itemName] = harvestValue;

                this._removeItemFromArray(this._expiredItems, itemName); // Item is no longer expired
                this._removeItemFromArray(this._harvestQueue, itemName); // Item is no longer being harvested
                
                // this._logInformation('_loadSingleItem: Harvesting completed. Name(' + itemName + '). Value(' + harvestValue + ')');
            }
            catch (e)
            {
                this._logError('_harvest: ' + e.message);
            }
        },

        /* Apply operation on a value based on it's definition
        *   Will call the operations singleton to apply the operation
        *
        * PARAMS:
        *   itemName: target data_item name
        *   operationConfig: item operationConfig definition retrieved from data_items.json - Can be null
        */
        "_processOperation": function (itemName, operationConfig)
        {
            // this._logInformation('Processing operation for (' + itemName + ') with operationConfig (' + JSON.stringify(operationConfig) + ')');
            var harvestValue = this._rawDataStore[itemName];

            var operations = ModuleManager.getSingleton("operations");
            var postOperationValue = operations.apply(harvestValue, operationConfig);
            this._removeItemFromArray(this._operationExpiredItems, itemName);

            return postOperationValue;
        },

        /* Apply the refresh function for the target datapoint
        *   (Harvest again if value doesn't exist yet. Reload after time out. Apply operation every time)
        *
        * PARAMS:
        *   itemName: target data_item name
        *   refreshConfig: item refreshConfig definition retrieved from data_items.json - Can be null
        */
        "_setRefreshers": function (itemName, refreshConfig)
        {
            if (!refreshConfig)
            {
                // Item doesn't have any refresh config. Normal..
                return;
            }

            for (var action in refreshConfig)
            {
                try
                {
                    // Apply refresh action
                    this._refreshers[action](itemName, refreshConfig[action]);
                }
                catch (e)
                {
                    this._logError('_setRefreshers: ' + e.message);
                }
            }
        },

        "_retrieveFromDataStore": function(params)
        {
            try
            {
                this._logInformation('Requesting item from data_collector: ' + JSON.stringify(params));

                if (typeof params === "string")
                {
                    var result = this.get(params);
                    return result;
                }

                var result = [];
                var dataIems = this.get(params);
                if (!dataIems)
                {
                    return [];
                }

                for (var idx in params)
                {
                    var itemName = params[idx];
                    result.push(dataIems[itemName]);
                }

                return result;
            }
            catch (e)
            {
                this._logError('_retrieveFromDataStore: ' + e.message);
            }
        },
         "_requestFromMsgBus": function(params)
        {
            try
            {
                this._logInformation('Requesting item from Msgbus: ' + JSON.stringify(params));

                if (typeof params != "object")
                {
                    logError("_requestFromMsgBus: params not an object!");
                    return null;
                }

                var plugin = getMessageBus();
                if (!plugin)
                {
                    logError("Current MsgBus Plugin does not support request/response.");
                    return null;
                }

                var result = plugin.Request(params["name"], params["data"]);

                var dataOut = JSON.parse(result)

                //this._logInformation('Got back from Msgbus: ' + JSON.stringify(dataOut["payload"]));
                return dataOut["payload"];
            }
            catch (e)
            {
                this._logError('_requestFromMsgBus: ' + e.message);
            }
        },

        "_createRefreshers": function (data_collector_engine)
        {
            var refreshers =
            {
                "harvestIfEq": function(itemName, value)
                {
                    if (data_collector_engine._cache[itemName] === value)
                    {
                        data_collector_engine.markDataExpired(itemName);
                    }
                },
                "harvestTimeout": function(itemName, value)
                {
                    setTimeout(function () { data_collector_engine.markDataExpired(itemName);; } , value);
                },
                "operationTimeout": function (itemName, value)
                {
                    setTimeout(function () { data_collector_engine.markDataOperationExpired(itemName); } , value);
                },
                "onMessageBusMsg": function (itemName, value)
                {
                    data_collector_engine._subscribeToMsgBusRefreshMsgs(itemName, value);
                }
            };
            return refreshers;
        },

        "_createFarmers": function (data_collector_engine)
        {
            var farmers =
				{
				"UWPStorage": function (params)
				{
					var uwp_storage = ModuleManager.getSingleton("uwp_storage");
					return uwp_storage.get(params);
				},
                "registry": function (params)
                {
                    var registry = ModuleManager.getSingleton("registry");
                    return registry.fetchFromDataDefinition(params);
                },
                "registryCustom" :function (params)
                {
                    var registry= ModuleManager.getSingleton("registry");
                    return registry.executeAction(params);
                },
                "csp": function (params)
                {
                    var csp_client = ModuleManager.getSingleton("csp_client");
                    return csp_client.fetchFromDataDefinition(params);
                },
                "subdb": function (params)
                {
                    var subdb = ModuleManager.getSingleton("subdb");
                    return subdb.fetchFromDataDefinition(params);
                },
                "wmi": function (params)
                {
                    var wmi = ModuleManager.getSingleton("wmi");
                    return wmi.fetchFromDataDefinition(params);
                },
                "dataCollector": function (params)
                {
                    return data_collector_engine._retrieveFromDataStore(params);
                },
                "dataAggregator": function (params)
                {
                    var dataAggregator = ModuleManager.getSingleton("dataset_da");
                    return dataAggregator.get(params);
                },
                "fileVersion": function (params)
                {
                    var systemPlugin = getSystemPlugin();

                    var fullPath = systemPlugin.GetKnownFolder(params);
                    if (!fullPath)
                    {
                        return null;
                    }
                    return systemPlugin.GetFileVersion(fullPath);
                },
                "fileVersionEx": function (params)
                {
                    var folder = params['directory'];
                    var file = params['file'];
                    var systemPlugin = getSystemPlugin();

                    var fullPath = systemPlugin.GetKnownFolder(folder);
                    if (!fullPath)
                    {
                        return null;
                    }
                    fullPath += "\\" + file;
                    
                    return systemPlugin.GetFileVersion(fullPath);
                },
                "creationDate": function (params)
                {
                    var wmi = ModuleManager.getSingleton("wmi");
                    return wmi.getTargetPathCreationDate(params);
                },
                "wmiCustom" :function (params)
                {
                    var wmi = ModuleManager.getSingleton("wmi");
                    return wmi.executeAction(params);
                },
                "transportStatus": function (params)
                {
                    try
                    {
                        var transportProfiles = ModuleManager.getSingleton("transport_config");
                        if (!transportProfiles)
                        {
                            return null;
                        }
                        var target_profile = transportProfiles[params];
                        if (!target_profile)
                        {
                            data_collector_engine._logError('transportStatus:: No such profile(' + params + ')');
                            return null;
                        }

                        var emitter = createEmitter(params, target_profile);
                        return emitter._isEnabled() ? true : false;
                    }
                    catch (e)
                    {
                        data_collector_engine._logError('transportStatus: ' + e.message);
                    }
                },
                "settingsManager": function(params)
                {
                    return StorageManager.get(params);
                },
                "msgBusSource": function (params)
                {
                    return data_collector_engine._requestFromMsgBus(params);
                },
                "iniFile": function (params)
                {
                    return GetKeyValueFromINIFile(params);
                },
                "aleSetting": function (params)
                {
                    return GetSetting(params);
                }
            };
            return farmers;
        },

        "_logInformation": function (msg)
        {
            logInformation('data_collector: ' + msg);
        },
        "_logError": function (msg)
        {
            logError('data_collector: ' + msg);
        },

        "_farmers": null,               // Farmers are responsible of harvesting data points. Gets defined at run time, since it requires the data_collector object
        "_refreshers": {},              // Refreshers can set a timeout to recollect the datapoint or reapply an opration. Gets defined at run time, since it requires the data_collector object
        "_harvestQueue": [],            // List of items being harvested. Used to eliminate circular dependencies
        "_expiredItems": [],            // A list of expired items and need to be collected again
        "_expiryQueue": [],             // List of items being marked expired. Used to eliminate circular dependencies
        "_operationExpiredItems": [],   // A list of expired items and need to be collected again
        "_rawDataStore": {},            // A collection of items harvested, but not operated on yet (raw data)
        "_cache": {},               // Contains loaded values (post operations)
        "_definitions": {},             // Definitions of how to collect each datapoint
        "_subscribedMsgs": {},          // Has a list of msg bus subscribed msgs and the corresponding datapoints

        /**********************************************************************************************
        ***********************************************************************************************
                Array Manipulations
        ***********************************************************************************************
        ***********************************************************************************************/

        /* Checks if an item exists in an array
         * PARAMS:
         *  array: array to be searched
         *  itemName: search value
         *
         * RETURN:
         *  true: if exists, false otherwise
         */
        "_arrayIncludes": function (array, itemName)
        {
            for (var idx in array)
            {
                if (itemName == array[idx])
                {
                    return true;
                }
            }

            return false;
        },

        /* Finds the common elements in two arrays
        * PARAMS:
        *  array1: First array
        *  array2: Second array
        *
        *  RETURN:
        *   Array of the common elements
        */
        "_getCommonElements": function (array1, array2)
        {
            var result = [];
            for (var idx1 in array1)
            {
                if (this._arrayIncludes(array2, array1[idx1]))
                {
                    result.push(array1[idx1]);
                }
            }
            return result;
        },

        /* Deletes items from an array - first occurence
         *
         * PARAMS:
         *  array: target array
         *  itemName: search value
         *
         * RETURN:
         *  true: if exists, false otherwise
         */
        "_removeItemFromArray": function (array, itemName)
        {
            for (var idx in array)
            {
                if (itemName == array[idx])
                {
                    array.splice(idx, 1);
                    break;
                }
            }
        }
        
    };

    data_collector.setup();
    return data_collector;

}

ModuleManager.registerFactory("data_collector", Create_data_collector);
//export  {Create_data_collector};
//globalEngine.FactoryMap["data_collector"] =  Create_data_collector;
